import styled from 'styled-components';

export const AutosizeTextareaContainer = styled.textarea`
  overflow: 'hidden';
  height: 'auto';
  line-height: '24px';
  resize: 'none';
`;
